<template>
  <div class="app-showcase-process-step__one pb-30">
    <div class="row" v-if="left">
      <div class="col-lg-5 col-md-5">
        <div class="app-showcase-process-step__media text-center wow move-up">
          <v-img :src="img" height="320px"></v-img>
        </div>
      </div>
      <div class="col-lg-7 col-md-7">
        <div class="app-showcase-process-step__content section-space--mt_15 text-left float-left">
          <div class="app-showcase__inner">
            <div class="sub__title mb-20 wow move-up">
              <h6 class="font-weight--blod">{{ title }}</h6>
            </div>
            <h4 class="font-weight--light wow move-up">{{ subtitle }}</h4>
            <div v-html="`${desc}`" class="sub-text section-space--mb_40 wow move-up"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-lg-7 col-md-7">
        <div class="app-showcase-process-step__content section-space--mt_15 text-right float-right">
            <div class="sub__title mb-20 wow move-up">
              <h6 class="font-weight--blod">{{  title }}</h6>
            </div>
            <h4 class="font-weight--light wow move-up">{{ subtitle }}</h4>
            <div v-html="`${desc}`" class="sub-text section-space--mb_40 wow move-up"></div>
        </div>
      </div>
      <div class="col-lg-5 col-md-5">
        <div class="app-showcase-process-step__media text-center wow move-up">
          <v-img :src="img" height="320px"></v-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginScreen',
  props: ['img', 'subtitle', 'title', 'desc','left'],
};
</script>
